import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { StatusBarService } from './status-bar.service';
import { IStatusBar } from '../common/inject';
import * as settings from '../common/settings';
import * as enums from '../common/enums';
import * as aspObjects from '../asp/aspObjects';
import { mainMapMngr } from '../asp/MapMngr';

//
// Status Bar
//
@Component({
  selector: 'status-bar',
  templateUrl: './status-bar.component.html',
  styleUrls: ['./status-bar.component.scss']
})
export class StatusBarComponent implements OnInit, AfterViewInit, IStatusBar {

  tracksCounter: string;
  sensorTracksCounter: string;
  sensorsCounter: string;
  plotsCounter: string;
  vectorCounter: string;

  @ViewChild('statusBar', { read: ElementRef, static: false }) statusBar: ElementRef;

  constructor(private statusBarService: StatusBarService) {
    statusBarService.statusBar = this;
    this.refresh();
  }

  ngOnInit() {
  }

  isVisible() {
    if (settings.userSettings.userPerm == enums.Permission.USER)
      return false;
    return this.statusBarService.statusBarVisible;
  }

  ngAfterViewInit() {
    settings.setStatusBarHeight(this.isVisible() ? this.statusBar.nativeElement.offsetHeight : 0);
  }

  refresh() {
    if (!this.isVisible())
      return;
    
    let tracksCount = aspObjects.tracksPool ? aspObjects.tracksPool.objectsCount() : 0;
    let sensorsCount = aspObjects.sensorsPool ? aspObjects.sensorsPool.objectsCount() : 0;
    let plotsCount = aspObjects.plotsPool ? aspObjects.plotsPool.objectsCount() : 0;
    let vectorCount = aspObjects.acousticVectorPool ? aspObjects.acousticVectorPool.objectsCount() : 0;

    let visTracksCount = mainMapMngr.tracksDrawer ? mainMapMngr.tracksDrawer.visibleCount() : 0;
    let visSensorsCount = mainMapMngr.sensorsDrawer ? mainMapMngr.sensorsDrawer.visibleCount() : 0;
    let visPlotsCount = mainMapMngr.plotsDrawer ? mainMapMngr.plotsDrawer.visibleCount() : 0;
    let visVectorCount = mainMapMngr.acousticVectorDrawer ? mainMapMngr.acousticVectorDrawer.visibleCount() : 0;

    this.tracksCounter = `${visTracksCount.toString().padStart(3, '0')} / ${tracksCount.toString().padStart(3, '0')}`;
    this.sensorsCounter = `${visSensorsCount.toString().padStart(3, '0')} / ${sensorsCount.toString().padStart(3, '0')}`;
    this.plotsCounter = `${visPlotsCount.toString().padStart(4, '0')} / ${plotsCount.toString().padStart(4, '0')}`;
    this.vectorCounter = `${visVectorCount.toString().padStart(4, '0')} / ${vectorCount.toString().padStart(4, '0')}`;
  }
}
